import { render, staticRenderFns } from "./SetSystem.vue?vue&type=template&id=cade1fba&scoped=true&"
import script from "./SetSystem.vue?vue&type=script&lang=js&"
export * from "./SetSystem.vue?vue&type=script&lang=js&"
import style0 from "./SetSystem.vue?vue&type=style&index=0&id=cade1fba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cade1fba",
  null
  
)

export default component.exports